import { Map } from 'immutable';

export const root = state => state.get('paginatedItems');
export const paginationByUrl = (state, url) => root(state).get(url, new Map());
export const isLoadingByUrl = (state, url) => paginationByUrl(state, url).get('isLoading', false);
